import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';

import ProviderDetails from './ProviderDetails';
import Button from '../../../components/Button';
import AvailabilityGrid from '../../../components/AvailabilityGrid';
import AvailabilityLegend from '../../../components/AvailabilityLegend';

import * as authApi from '../../../services/api/auth';

function BookAppointmentSearch(props) {
  const {
    providers = [],
    handleSelectAppointment,
    handleRefferalSelected,
    onPageChange,
    Loading,
    offSetValue,
    classes: { root, providerRow },
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  let [obKey, setObKey] = useState('');

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        const user = await authApi.fetchCurrentUser();
        setCurrentUser(user);
      } catch (err) {
        enqueueSnackbar('Ooops, something went wrong, Please try again.');
      }
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (providers.length) {
      setObKey('comp0');
    }
  }, [providers]);
  return isLoading ? (
    <Grid container justifyContent="center" alignItems="center">
      <CircularProgress />
    </Grid>
  ) : (
    <div className={root}>
      {providers?.map((provider, i) => {
        return (
          <div key={provider.id} className={providerRow}>
            <ProviderDetails
              provider={provider}
              referPatientCallback={(provider) =>
                handleRefferalSelected({
                  referredProvider: provider,
                  referringProvider: currentUser,
                })
              }
            />
            <AvailabilityLegend tenancies={provider.tenancies} />
            <AvailabilityGrid
              objKey={'comp' + i}
              nxKey={'comp' + (i + 1)}
              obKey={obKey}
              setObKey={setObKey}
              provider={provider}
              Loading={Loading}
              referPatientCallback={(provider) =>
                handleRefferalSelected({
                  referredProvider: provider,
                  referringProvider: currentUser,
                })
              }
              appointmentSelected={(appt, provider) =>
                handleSelectAppointment({
                  ...appt,
                  provider,
                })
              }
              onError={() =>
                enqueueSnackbar('Ooops, an error occured. Please try again.')
              }
            />
          </div>
        );
      })}
      {providers.length > 0 && (
        <Grid container>
          <Button
            onClick={() => onPageChange('prev')}
            disabled={offSetValue == 0}
          >
            prev
          </Button>
          <Button
            onClick={() => onPageChange('next')}
            disabled={!providers.length}
          >
            next
          </Button>
        </Grid>
      )}
    </div>
  );
}

const styles = () => ({
  root: {
    padding: '16px',
  },
  providerRow: {
    padding: '30px 24px',
    borderBottom: '1px solid #979797',
    '&:last-child': {
      borderBottom: 'none',
    },
  },
});

BookAppointmentSearch.propTypes = {
  specialty: PropTypes.object,
  practice: PropTypes.object,
  providerName: PropTypes.string,
};

export default withStyles(styles)(BookAppointmentSearch);
